export const OPTIONS_GIBDD = [
  "id",
  "vin",
  "dateRegistration",
  "city",
  "district",
  "region",
  "federalArea",
  "createdAt",
  "updatedAt",
];
